import { Button } from '@cmsgov/ds-medicare-gov';
import type { Lang } from '../constants';
import { t } from '../i18n';
import { LoadingSpinner } from './LoadingSpinner';

interface LoadMoreProps {
  lang: Lang;
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
}

export function LoadMore({
  lang,
  hasMore,
  loading,
  onLoadMore,
}: LoadMoreProps) {
  const strings = t(lang);

  if (!hasMore) return null;

  return (
    <div className="app-library-search__load-more ds-u-margin-top--3 ds-u-text-align--center">
      <Button onClick={onLoadMore} disabled={loading} isAlternate>
        {loading ? <LoadingSpinner lang={lang} inline /> : strings.loadMore}
      </Button>
    </div>
  );
}
